import { Carousel } from '@sravni/react-design-system/lib/Carousel';
import { Heading } from '@sravni/react-design-system/lib/Typography';

import { BlankStampSvgIcon } from '@src/components/icons/BlankStampSvgIcon';
import { CompareAddedSvgIcon } from '@src/components/icons/CompareAddedSvgIcon';
import { ContactSvgIcon } from '@src/components/icons/ContactSvgIcon';
import { MoneyCoinsSvgIcon } from '@src/components/icons/MoneyCoinsSvgIcon';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

import { SeoStepCard } from '../SeoStepCard/SeoStepCard';

import styles from './SeoGuideCarousel.module.scss';
import { SeoGuideCarouselTexts } from './SeoGuideCarousel.texts';

const CONTENT = [
  {
    step: 1,
    id: '1',
    title: `Выберите займ на витрине${UNBREAKABLE_SEPARATOR}предложений`,
    description:
      'Сравните предложения МФО и выберите лучшее. Все МФО в реестре ЦБ РФ. Воспользуйтесь фильтром, чтобы подобрать нужные сумму и срок.',
    icon: <CompareAddedSvgIcon />,
  },
  {
    step: 2,
    id: '2',
    title: (
      <>
        Регистрация на
        <br />
        Сравни.ру
      </>
    ),
    description:
      'Зарегистрируйтесь любым удобным способом. У вас будет личный кабинет, где можно отслеживать информацию и статусы по заявкам.',
    icon: <ContactSvgIcon />,
  },
  {
    step: 3,
    id: '3',
    title: 'Оформление заявки без визита в МФО',
    description:
      'Выберите предложение и нажмите «Получить». Оформите займ онлайн прямо в контуре Сравни.ру — без перехода на сторонние сайты.',
    icon: <BlankStampSvgIcon />,
  },
  {
    step: 4,
    id: '4',
    title: (
      <>
        Получение займа
        <br />
        онлайн
      </>
    ),
    description:
      'Через 3–5 минут получите решение по одобрению. Деньги поступают на карту или счёт, указанный в заявке.',
    icon: <MoneyCoinsSvgIcon />,
  },
];

export function SeoGuideCarousel() {
  return (
    <Carousel
      title={
        <Heading level={2} className={styles.title}>
          {SeoGuideCarouselTexts.title}
        </Heading>
      }
      gap={16}
      className={styles.container}
    >
      {CONTENT.map((item) => (
        <SeoStepCard key={item.id} {...item} />
      ))}
    </Carousel>
  );
}
